"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _SocialGroup = _interopRequireDefault(require("../../../../common/components/SocialGroup"));

var _Elements = require("./Elements");

var _constants = require("../../../../constants/constants");

var Footer = function Footer(_ref) {
  var _Date, _Date$getFullYear;

  var name = _ref.name,
      tosUrl = _ref.tosUrl,
      policyUrl = _ref.policyUrl,
      visibilityOptions = _ref.visibilityOptions,
      socialMedia = _ref.socialMedia,
      username = _ref.username,
      colour = _ref.colour,
      isCustomTos = _ref.isCustomTos,
      isCustomPolicy = _ref.isCustomPolicy;
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });

  var renderSocialLogo = /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions,
    username: username,
    fontColor: colour
  }));

  var CopyRight = /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.footer.copyright",
    values: {
      name: name,
      year: ((_Date = new Date()) === null || _Date === void 0 ? void 0 : (_Date$getFullYear = _Date.getFullYear) === null || _Date$getFullYear === void 0 ? void 0 : _Date$getFullYear.call(_Date)) || '2022'
    }
  }));

  var TOSLink = /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    style: {
      cursor: 'pointer'
    },
    underline: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    target: isCustomTos ? '_blank' : undefined,
    to: {
      pathname: tosUrl
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.footer.link.terms_of_use"
  })));

  var PrivacyLink = /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    style: {
      cursor: 'pointer'
    },
    underline: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    target: isCustomPolicy ? '_blank' : undefined,
    to: {
      pathname: policyUrl
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.footer.link.privacy_policy"
  })));

  var By500 = /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.footer.power_by_500px",
    values: {
      link: /*#__PURE__*/_react["default"].createElement(_Elements.PowerBy500px, {
        as: "span",
        portfolioFontFamily: true,
        portfolioForeground1: true,
        underline: true
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.500px.com",
        target: "_blank",
        rel: "noreferrer"
      }, "500px"))
    }
  }));

  var spacer = /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    mx: "xs",
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, "|"); // Mobile


  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    mb: "sm",
    flex: true,
    align: "center",
    flexWrap: true,
    justify: "center"
  }, CopyRight, (tosUrl || policyUrl) && spacer, tosUrl && TOSLink, tosUrl && policyUrl && spacer, policyUrl && PrivacyLink), By500); // 768px+ - effectively desktop display


  if (isTabletPortrait) {
    content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      flex: true,
      align: "center"
    }, CopyRight, (tosUrl || policyUrl) && spacer, tosUrl && TOSLink, tosUrl && policyUrl && spacer, policyUrl && PrivacyLink), By500);
  } // 667px - 767px - 'tablet'


  if (isMobileLandScape) {
    content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      flex: true,
      align: "center"
    }, CopyRight), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
      flex: true
    }, tosUrl && TOSLink, tosUrl && policyUrl && spacer, policyUrl && PrivacyLink, (tosUrl || policyUrl) && spacer, By500));
  }

  return /*#__PURE__*/_react["default"].createElement(_Elements.FooterBox, null, renderSocialLogo, /*#__PURE__*/_react["default"].createElement(_Elements.CopyRightBox, {
    colour: _constants.PORTFOLIO_THEME_COLOR[colour]
  }, content));
};

Footer.defaultProps = {
  name: '',
  tosUrl: '/terms',
  policyUrl: '/policy',
  socialMedia: {
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    pxProfile: 'VISIBLE'
  },
  username: '',
  colour: ''
};
Footer.propTypes = {
  name: _propTypes["default"].string,
  tosUrl: _propTypes["default"].string,
  policyUrl: _propTypes["default"].string,
  socialMedia: _propTypes["default"].shape({
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  }),
  username: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  isCustomTos: _propTypes["default"].bool.isRequired,
  isCustomPolicy: _propTypes["default"].bool.isRequired
};
var _default = Footer;
exports["default"] = _default;